<button
  #filterButton
  *ngIf="!isMobile; else drawerButton"
  class="filter-btn"
  nz-button
  nz-dropdown
  nzSize="small"
  nzTrigger="click"
  nzPlacement="bottomRight"
  [nzNoAnimation]="true"
  [nzDropdownMenu]="dropdownTemplate"
  [nzVisible]="isDropdownOpen"
  (nzVisibleChange)="toggle($event)">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" fill="#EB194B"/>
  </svg>
  
  {{ filterTotal ? 'Filtros (' + filterTotal + ')'  : 'Filtros' }}
  <span nz-icon nzType="down" class="arrow-select"></span>
</button>

<nz-dropdown-menu
  #dropdownTemplate="nzDropdownMenu">
  <div *ngIf="isDropdownOpen">
    <ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
  </div>
</nz-dropdown-menu>

<nz-drawer
  [nzClosable]="true"
  [nzTitle]="filterTitleTemplate"
  [nzVisible]="isDrawerOpen"
  [nzPlacement]="'bottom'"
  [nzBodyStyle]="{padding: 0}"
  (nzOnClose)="close()"
  nzHeight="calc(100% - 73px)"
  nzWrapClassName="search-filter__wrapper">
  <ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
</nz-drawer>

<ng-template #filterTitleTemplate>
  <h3 class="search-bar__filter-title">
    {{ filterTotal ? 'Filtros (' + filterTotal + ')'  : 'Filtros' }}
  </h3>
</ng-template>

<ng-template #filterTemplate>
  <lps-search-filter
    [theme]="'broker_crm'"
    [value]="filterValue"
    [showOperationType]="showOperationType"
    (valueChange)="changeFilter($event)">
  </lps-search-filter>
</ng-template>

<ng-template #drawerButton>
  <button
    class="filter-btn"
    nz-button
    nzSize="small"
    [nzNoAnimation]="true"
    (click)="toggle(true)">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" fill="#EB194B"/>
    </svg>
      
    {{ filterTotal ? 'Filtros (' + filterTotal + ')'  : 'Filtros' }}
    <span nz-icon nzType="down" class="arrow-select"></span>
  </button>
</ng-template>